/* Default theme. ~960B */
/* @import '../../../node_modules/@vime/core/themes/default.css'; */

/* Optional light theme (extends default). ~400B */
/* @import '../../../node_modules/@vime/core/themes/light.css'; */

@import '../../../node_modules/plyr/dist/plyr.css';


.player {
  min-width: 90px !important;
  min-height: 160px !important;
}

.player { min-width: 100px !important; height: 100% !important; }

:host {
  display: block;
  padding:0;
  margin:0;
  width: 100%;
  height: 100%;
  max-height: 100%;
  font-family: inherit !important;
}

vm-player[video] {
  /* Add styles here for when the media is of type `video`. */
  width: 100%;
  --vm-player-border-radius: 0px;
  --vm-control-spacing: 12px;
  height: 100%;
  --vm-control-bg: rgba(0,0,0,0.25);
  --vm-control-bg: rgba(45, 45, 45, 0.7);
  --vm-control-focus-bg: rgba(45, 45, 45, 0.7);
  --vm-control-border-radius: 50%;
  position: relative;
}

.playerWrapper.fullscreen vm-player[video] {
  --vm-control-icon-size: 24px;
  --vm-player-border-radius: 0px;
  --vm-control-padding: 7px;
  --vm-control-border: 1px solid #fff;
}

.playerWrapper {
  padding:0;
  margin:0;
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  -webkit-background-clip: padding-box; 
  -moz-background-clip:    padding; 
  background-clip:         padding-box;
  width: 100%;
  max-height: 100vh;
  max-width: calc(100vh * 9/16);
  margin: auto;
  background-color: transparent;
  overflow: hidden;
  z-index: 1;
  -webkit-background-clip: padding-box; 
  -moz-background-clip:    padding; 
  background-clip:         padding-box;
}

@media(min-width: 576px) {
  .playerWrapper {
    aspect-ratio: 9/16;
    width: auto !important;
  }
}

.playerWrapper.sizemini {
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
}

.plyr {
  min-width: 100px !important;
  -webkit-background-clip: padding-box; 
  -moz-background-clip:    padding; 
  background-clip:         padding-box;
}

.playerWrapper.pinned vm-player[video] {
  --vm-player-border-radius: 0px;
  --vm-control-bg: transparent;
}

.playerWrapper.pinned.show {
  display: block;
}

.playerWrapper.pinned {
  border-radius: 6px;
  -webkit-boder-radius: 6px;
  -moz-border-radius: 6px;
}

.playerWrapper.pinned.sizemini {
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
}

.playerWrapper.pinned {
  display: none;
  background-color: transparent;
  width: calc(var(--asplayer-ch,320px) * 9/16);
  height: var(--asplayer-ch,320px);
  position: fixed;
  z-index: 9;
  touch-action: manipulation;
  outline: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  transform-origin: center;
  -webkit-transform: translate3d( var(--asplayer-translate-x, 0), var(--asplayer-translate-y, 0), 0 );
  -moz-transform: translate3d( var(--asplayer-translate-x, 0), var(--asplayer-translate-y, 0), 0 );
  -ms-transform: translate3d( var(--asplayer-translate-x, 0), var(--asplayer-translate-y, 0), 0 );
  transform: translate3d( var(--asplayer-translate-x, 0), var(--asplayer-translate-y, 0), 0 );
  margin: var( --asplayer-margin, 8px );
  top: var(--asplayer-pip-top, 0);
  right: var(--asplayer-pip-right, auto);
  bottom: var(--asplayer-pip-bottom, auto);
  left: var(--asplayer-pip-left, 0);
    /* inset: var(--player-inset, 0 auto auto 0); */
}

.backdrop {
  display: none;
  background: rgba(0,0,0,0.7);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9998;
  cursor: pointer;
}

.backdrop.fullscreen {
  display: block;
}

.playerWrapper.fullscreen .plyr {
  border-radius: 0px;
  -webkit-border-radius: 0px;
  -moz-border-radius: 0px;
}

.playerWrapper.fullscreen {
  background-color: transparent;
  /* border-radius: 0px;
  -webkit-border-radius: 0px;
  -moz-border-radius: 0px; */
  position: fixed;
  touch-action: manipulation;
  outline: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    transform-origin: center;
    -webkit-transform: translate3d( var(--asplayer-translate-x, 0), var(--asplayer-translate-y, 0), 0 );
    -moz-transform: translate3d( var(--asplayer-translate-x, 0), var(--asplayer-translate-y, 0), 0 );
    -ms-transform: translate3d( var(--asplayer-translate-x, 0), var(--asplayer-translate-y, 0), 0 );
    transform: translate3d( var(--asplayer-translate-x, 0), var(--asplayer-translate-y, 0), 0 );
    margin: 0px auto;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2147483647;
    /* inset: var(--player-inset, 0 auto auto 0); */
}

@media(max-width: 576px) {
  .playerWrapper.fullscreen {
  border-radius: 0px;
  -webkit-border-radius: 0px;
  -moz-border-radius: 0px;
  }
}

.playerWrapper.pinned.hidden {
  visibility: hidden;
  height: 0px;
  opacity: 0;
}

.playerWrapper.pinned.br {
  --asplayer-pip-top: auto;
  --asplayer-pip-right: 0;
  --asplayer-pip-bottom: 0;
  --asplayer-pip-left: auto;
}

.playerWrapper.pinned.bl {
  --asplayer-pip-top: auto;
  --asplayer-pip-right: auto;
  --asplayer-pip-bottom: 0;
  --asplayer-pip-left: 0;
}

.playerWrapper.pinned.tr {
  --asplayer-pip-top: 0;
  --asplayer-pip-right: 0;
  --asplayer-pip-bottom: auto;
  --asplayer-pip-left: auto;
}

.playerWrapper.pinned.tl {
  --asplayer-pip-top: 0;
  --asplayer-pip-right: auto;
  --asplayer-pip-bottom: auto;
  --asplayer-pip-left: 0;
}

/* video {
  aspect-ratio: 9/16;
} */

video {
  background: #000;
}

.videoTitle {
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  height: 24px;
  line-height: 24px;
  white-space: nowrap;
  font-weight: 500;
  font-size: 14px;
}
.videoTitleText {
  color: #fff;
  overflow: hidden;
  display: block;
  height: 28px;
  text-overflow: ellipsis;
}

.footerTitle .footerTitleText   {
  font-size: 18px;
  line-height: 24px !important;
  font-weight: 400;
  text-shadow: 0 0 1px rgb(0 0 0 / 50%);
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  box-orient: vertical;
  -webkit-box-orient: vertical;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #fff !important;
  word-wrap: break-word;
  word-break: break-all;
}

.topPlayerShow {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  height: 33.33%;
  max-height: 80px;
  /* background-image: linear-gradient(rgba(43, 43, 43, 0.3), rgba(43, 43, 43, 0)); */
  /* background-image: linear-gradient(180deg, #272727 0%, rgba(45, 45, 45, 0) 100%); */
  width: 100%;
}

.bottomPlayerShow {
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: 33.33%;
  background-image: linear-gradient(to top, rgba(43, 43, 43, 0.5), rgba(43, 43, 43, 0));
  width: 100%;
}

.fullplayerclick {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: inline-block;
  cursor: pointer;
  z-index: 999;
}

.closeIcon{
  height: var(--vm-control-icon-size);
  width: var(--vm-control-icon-size);
  overflow: hidden;
}

.closeIcon:after{
  display: inline-block;
  content: "\00d7"; /* This will render the 'X' */
  font-size: var(--vm-control-icon-size);
  line-height: var(--vm-control-icon-size);
  position: relative;
  top: -2px;
}

.flexWrapper {
  box-sizing: border-box;
  min-height: calc(100% - 80px);
  display: flex;
  flex-direction: column;
  position:absolute;
  width: 100%;
  top: 80px;
  text-align: left;
}

.vmWrapper {
  flex-grow: 1;
  align-items: stretch;
  display: flex;
  z-index: 1;
}

.ctaLinkContainer {
  flex-grow: 0;
  flex-shrink: 0;
  /* position: absolute;
  bottom: 16px;
  left: 8px;
  right: 8px; */
  margin: 0;
  padding: 0px calc(min(12px, 3%)) 16px;
  z-index: 10000;
} 
.ctaLinkContainer.no-padding {
  padding-left:0px;
  padding-right: 0px;
}

.sizemini  .ctaLinkContainer {
  padding-bottom: 4px;
}
.playerWrapper.fullscreen .ctaLinkContainer  {
  bottom: 40px;
}
.ctaLink {
  position: relative;
  display: inline-block;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  z-index: 100;
  padding: 8px 16px;
  height: auto;
  font-size: 18px;
  font-weight: 500;
  line-height: 36px;
  vertical-align: middle;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  margin-bottom: 0px;
  box-shadow: 2px 7px 96px -2px rgba(255, 255, 255,0.5);
  -webkit-box-shadow: 2px 7px 96px -2px rgba(255, 255, 255,0.5);
  -moz-box-shadow: 2px 7px 96px -2px rgba(255, 255, 255,0.5);
}

.ctaLink.large {
  display: block;
}

.ctaLink.small {
  float: right;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 40px;
  height: 40px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 32px;
  height: 32px;
  margin: 4px;
  border: 4px solid #fff;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.toastMessage {
  background-color: rgba(0,0,0,0.7);
  color: #fff;
  display: inline-block;
  padding: 8px 16px;
  text-align: left;
  width: 100%;
  font-size: 14px;
  line-height: 1.2;
}

.ctaLink::after {
  opacity:0;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-flex-direction:row;
  -ms-flex-direction:row;
  flex-direction:row;
  -webkit-box-pack:center;
  -ms-flex-pack:center;
  -webkit-justify-content:center;
  justify-content:center;
  -webkit-align-items:center;
  -webkit-box-align:center;
  -ms-flex-align:center;
  align-items:center;
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  content:'';
  height:100%;
  width:100%;
  background:var(--asplayer-btn-color, var(--gradient));
  -webkit-animation-name:animation-cta;
  animation-name:animation-cta;
  -webkit-animation-duration:2s;
  animation-duration:2s;
  -webkit-animation-delay:0;
  animation-delay:0;
  -webkit-animation-iteration-count:infinite;
  animation-iteration-count:infinite;
  -webkit-animation-timing-function:cubic-bezier(0.65, 0, 0.34, 1);
  animation-timing-function:cubic-bezier(0.65, 0, 0.34, 1);
  z-index:-1;
  border-radius:4px;
}

@keyframes animation-cta{from{opacity:0.7;-webkit-transform:scale3d(1, 1, 1);-moz-transform:scale3d(1, 1, 1);-ms-transform:scale3d(1, 1, 1);transform:scale3d(1, 1, 1);}to{opacity:0;-webkit-transform:scale3d(1.2, 1.2, 1);-moz-transform:scale3d(1.2, 1.2, 1);-ms-transform:scale3d(1.2, 1.2, 1);transform:scale3d(1.2, 1.2, 1);}}

@-webkit-keyframes animation-cta{from{opacity:0.7;-webkit-transform:scale3d(1, 1, 1);-moz-transform:scale3d(1, 1, 1);-ms-transform:scale3d(1, 1, 1);transform:scale3d(1, 1, 1);}to{opacity:0;-webkit-transform:scale3d(1.2, 1.2, 1);-moz-transform:scale3d(1.2, 1.2, 1);-ms-transform:scale3d(1.2, 1.2, 1);transform:scale3d(1.2, 1.2, 1);}}

.as-player-wrapper {
  max-height: 100%;
  overflow: hidden;
}

.cards.dark {
  background-color: #000;
}

.cards {
  background: #fff;
  height: 100%;
  width: 100%;
  overflow: hidden;
  box-shadow: 5px 8px 15px -10px rgba(0,0,0,0.25);
  position: relative;
}
.cards.fullheight {
  position: absolute;
  top: 0px;
  left: 0px;
}
.z2 {
  z-index: 2;
}

.cards img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.card_image {
  width: 100%;
  height: 100%;
}
.card_image.loading {
  width: 100%;
  height: 100%;
}
.card_title {
  padding: 8px;
  font-size: 22px;
  font-weight: 700;
  position: absolute;
  bottom: 0px;
  left: 0px;
}
.card_title.loading {
  width: 50%;
  height: 1rem;
  margin: 1rem;
  border-radius: 3px;
  position: relative;
}
.card_description {
  padding: 8px;
  font-size: 16px;
}
.card_description.loading {
  height: 3rem;
  margin: 1rem;
  border-radius: 3px;
}
.loading {
  position: relative;
  background: #cccccc;
}
.playerWrapper.fullscreen .loading {
  background: #3a3a3a;
}
.loading:after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  transform: translateX(-100px);
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  animation: loading 0.8s infinite;
}
.playerWrapper.fullscreen .loading:after {
  background: linear-gradient(to right, #3a3a3a 0%, #3f3f3f 10%, #4a4a4a 20%, #3f3f3f 30%, #3a3a3a 50%, #3a3a3a 100%);
}
.playanimation {
  animation: pulse 1s infinite;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
}

.playanimation:hover {
  animation: none;
}

.playanimation {
  width: 40px;
  height: 40px;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 8px;
  color: #fff;
  background: rgba(0, 0, 0, 0.7);
}
.playanimation svg {
  fill: #fff;
}

.sizemini .playanimation {
  width: 32px;
  height: 32px;
  padding: 6px;
} 

.plyr__video-embed iframe, .plyr__video-wrapper--fixed-ratio video {
  object-fit: cover;
}

.plyr__progress {
  position: absolute;
  left: 4px;
  width: calc(100% - 16px);
  display: none;
  z-index: 10001;
  top: 4px;
}

.playerWrapper.reels .plyr__progress {
  display: block;
}


.fullscreen .plyr__progress {
  display: block;
}
.playerWrapper {
  --plyr-color-main: #121212;
  --plyr-video-progress-buffered-background: rgba(255, 255, 255, 0.5);
  --plyr-range-thumb-height: 1px;
  --plyr-range-fill-background: rgba(255,255,255, 1);
  --plyr-range-track-height: 2px;
  --plyr-control-icon-size: 24px;
  --plyr-range-thumb-active-shadow-width: 1px;
  --plyr-control-spacing: 10px;
  --plyr-control-radius: 50%;
}

.plyr--video .plyr__controls {
  top: 0px;
  bottom: inherit;
  background: linear-gradient(180deg, #272727 0%, rgba(45, 45, 45, 0) 100%);
  z-index: 10000;
  padding: 16px;
}
.playerWrapper .plyr--video .plyr__controls .plyr__control {
  padding: 7px;
  background: rgba(45, 45, 45, 0.7);
  border: 1px solid #fff;
  margin-left: 8px;
}

.playerWrapper.pinned .plyr--video .plyr__controls .plyr__control {
  background: transparent;
  border: 1px solid transparent;
}

.playerWrapper.pinned .plyr--video .plyr__controls .plyr__control:hover {
  background: rgba(45, 45, 45, 0.7);
}


/* .fullscreen .plyr--video {
  z-index: 10000;
} */

.playerWrapper.pinned .plyr {
  min-width: 100px;
}

.plyr--video .plyr__controls.footercontrols {
  bottom: 0px;
  top: inherit;
  background: linear-gradient(360deg, #272727 0%, rgba(45, 45, 45, 0) 100%);
  justify-content: flex-start;
}
.plyr--video .plyr__controls.footercontrols .plyr__control {
  margin-left: 0px;
}

.playerWrapper.pinned .plyr--video .plyr__controls {
  padding: 8px;
}

.playerWrapper.pinned .plyr {
  z-index: 10001;
}

.plyr--video {
  height: 100%;
}

.playerWrapper.cover .plyr video  {
  object-fit: cover;
}

.playerWrapper .plyr__poster {
  background-size: cover;
}

.plyr video {
  background: transparent;
}




@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }
  70% {
      -webkit-box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }
  100% {
      -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }
  70% {
      -moz-box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
      box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }
  100% {
      -moz-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

@keyframes pulse-white {
  0% {
      /*transform: scale(0.95);*/
      box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
  }

  70% {
      /*transform: scale(1);*/
      box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }

  100% {
      /*transform: scale(0.95);*/
      box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}


@keyframes loading {
  100% {
      transform: translateX(100%);
  }
}


